import React from 'react'
import {TYPENEW, TYPEEDIT} from '../../../state/constants'
import {Modal} from 'react-bootstrap'
import {AuditPaneContext} from '../../../context/AuditPane'
import {useTranslation} from 'react-i18next'
import upperCase from 'lodash/upperCase'

function Title() {
  const {t} = useTranslation()
  const paneState = React.useContext(AuditPaneContext)
  const titleName = () => {
    switch (upperCase(paneState.modalType)) {
      case TYPENEW:
        return t(`audit.audit-modal.create-a-new-audit`)
      case TYPEEDIT:
        if (paneState.modalFor === 'Audit') {
          return t(`audit.audit-modal.edit-audit`)
        } else {
          return t(`audit.audit-modal.edit-template`)
        }
      default:
        if (paneState.modalFor === 'Audit') {
          if (paneState.modalType === 'Schedule') {
            return t(`audit.audit-modal.run-audit`)
          }
          return t(`audit.audit-modal.duplicate-audit`)
        } else {
          return t(`audit.audit-modal.duplicate-template`)
        }
    }
  }

  return (
    <Modal.Header closeButton>
      <Modal.Title id="contained-modal-title-vcenter">{titleName()}</Modal.Title>
    </Modal.Header>
  )
}

export default Title
